import type {
  CreatePayComponentInput,
  EndPayComponentInput,
  PayComponentListResponse,
  PayComponentResponse,
} from '@kora/types';
import { apiRequest } from './client.js';

/**
 * Pay components API. Thin wrappers around /v1/pay-components endpoints.
 * Contract in apps/api/src/routes/pay-components.ts + @kora/types.
 */

export function listPayComponents(
  employeeId: string,
  opts: { includeEnded?: boolean } = {},
): Promise<PayComponentListResponse> {
  const qs = new URLSearchParams({ employeeId });
  if (opts.includeEnded) qs.set('includeEnded', 'true');
  return apiRequest<PayComponentListResponse>(`/v1/pay-components?${qs.toString()}`);
}

export function createPayComponent(
  input: CreatePayComponentInput,
): Promise<PayComponentResponse> {
  return apiRequest<PayComponentResponse>('/v1/pay-components', {
    method: 'POST',
    body: input,
  });
}

export function endPayComponent(
  id: string,
  input: EndPayComponentInput,
): Promise<PayComponentResponse> {
  return apiRequest<PayComponentResponse>(`/v1/pay-components/${id}/end`, {
    method: 'PATCH',
    body: input,
  });
}
